import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Button from "../../components/Button";
import Page from "../../components/Page";
import { Select } from "@mantine/core";
import "./styles.css";
import CompanyCard from "./CompanyCard";
import ads from "../../assets/home.gif";
import { backendUrl } from "../../constants";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/inputField";
import { loadCompaniesSearch } from "./loadData";
import { LoaderWrapper } from "../../components/LoaderWrapper";

const Index = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [loc, setLoc] = useState([]);
  const [searchCompany, setSearchCompany] = useState([]);
  const [filters, setFilters] = useState({});

  //location
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}empLocation/listEmpLocation`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.locationName };
          setLoc((loc) => [...loc, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //filters
  useEffect(() => {
    loadCompaniesSearch(filters, setLoading).then(setSearchCompany);
  }, [filters]);

  const clearSearch = () => {
    window.location.reload();
  };

  return (
    <Page className="landing-page">
      <div className="searchMain1">
        <h2 className="text-dark mb-0 mt-2">Search Company</h2>
        <div className="searchMain">
          <div className="filters">
            <p style={{ margin: "0px", fontWeight: "500" }}>Company Search</p>
            <InputField
              placeholder={"Company Name"}
              onBlur={(v) =>
                setFilters((filters) => ({
                  ...filters,
                  companyName: v.target.value,
                }))
              }
            />
            <Select
              label="Location"
              placeholder="Location..."
              data={loc}
              searchable
              creatable
              maxDropdownHeight={400}
              getCreateLabel={(query) => `${query}`}
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, location: v }))
              }
              filter={(value, item) =>
                item.label.toLowerCase().includes(value.toLowerCase().trim())
              }
            />

            <Button
              title={"Clear Search"}
              icon={"cross"}
              primary={true}
              fontWeight="700"
              type="submit"
              onClick={clearSearch}
              width="150px"
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                marginTop: "10px",
              }}
            />
          </div>
          <div className="jobs">
            <LoaderWrapper loading={loading}>
              {searchCompany.length < 1 ? (
                <h2 className="text-dark text-center">No company Found.</h2>
              ) : (
                searchCompany?.map((obj, key) => (
                  <CompanyCard data={obj} key={key} />
                ))
              )}
            </LoaderWrapper>
          </div>
          <div className="ads">
            <img src={ads} className="adimage" alt="" />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
